import NAME from "./constants";

export const getRows = store => store[NAME].rows;
export const getSelects = store => store[NAME].selects;
export const getLoading = store => store[NAME].loading;